export default __webpack_public_path__ + "static/media/Image2.85598c33.png";